import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import SwitchTenantModal from './SwitchTenantModal';
import OrgMultiSelectDropdown from './OrgMultiSelectDropdown';
import { Link } from 'react-router-dom';

const Header = () => {
  const [showUserMenu,    setShowUserMenu]    = useState(false);
  const [showTenantModal, setShowTenantModal] = useState(false);

  const {
    user,
    handleLogout,
    toggleSidebar,
    tenantList,
    selectedTenantId,
    selectedOrgIds,
    orgSwitching,
    setActiveOrgIds,
  } = useAuth();

  if (!user) return null;

  const safeTenantList  = Array.isArray(tenantList) ? tenantList : [];
  const currentTenant   = safeTenantList.find(t => String(t.id) === String(selectedTenantId));
  const tenantName      = currentTenant ? currentTenant.name : 'N/A';
  const fullName        = (user.first_name && user.last_name)
    ? `${user.first_name} ${user.last_name}`
    : user.username;
  const userInitials    = (fullName || 'U').slice(0, 2).toUpperCase();

  return (
    <header id="app-header">
      <div className="header-left">
        <button id="sidebar-toggle-btn" onClick={toggleSidebar} title="Toggle navigation sidebar" aria-label="Toggle navigation sidebar">{'☰'}</button>
        <Link to="/welcome" className="app-logo">Weave</Link>
      </div>

      <div className="header-right">
        <div id="tenant-info" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>

          {user.org_hierarchy?.length > 0 && (
            <OrgMultiSelectDropdown
              orgHierarchy={user.org_hierarchy}
              selectedIds={selectedOrgIds || []}
              onChange={setActiveOrgIds}
              variant="dark"
              loading={orgSwitching}
            />
          )}

          <div
            id="switch-tenant-btn"
            className="tenant-dropdown-toggle"
            onClick={() => safeTenantList.length > 1 && setShowTenantModal(true)}
            style={{
              display: 'inline-block',
              marginLeft: '8px',
              cursor: safeTenantList.length > 1 ? 'pointer' : 'not-allowed',
            }}
            title={safeTenantList.length > 1 ? 'Switch Tenant' : 'Only one tenant available'}
          />
        </div>

        <Link
          id="product-updates-link"
          to="/product-updates"
          title="Product Updates"
          aria-label="Product Updates"
          style={{ textDecoration: 'none', fontSize: '1.2rem', marginRight: '12px' }}
        >
          {'🔔'}
        </Link>

        <div
          id="user-profile"
          className="user-dropdown-container"
          onClick={() => setShowUserMenu(prev => !prev)}
        >
          <div className="user-avatar">{userInitials}</div>
          <span className="user-name">{fullName || 'User'} ▼</span>

          {showUserMenu && (
            <div className="dropdown-content user-menu-content">
              <div className="user-info-section">
                <p className="user-full-name">{fullName || 'N/A'}</p>
                <p className="user-email">{user.username || 'N/A'}</p>
                <p className="user-id">ID: {user.user_id || user.id || 'N/A'}</p>
              </div>

              <hr className="menu-divider" />

              <div className="tenant-switch-section">
                <p><strong>Tenant:</strong> {tenantName}</p>
                <button
                  className="switch-tenant-button"
                  onClick={() => setShowTenantModal(true)}
                  disabled={safeTenantList.length <= 1}
                >
                  Switch Tenants
                </button>
              </div>

              <hr className="menu-divider" />

              <Link
                to="/account/profile"
                className="logout-link"
                style={{ display: 'block', textDecoration: 'none', padding: '4px 0' }}
                onClick={() => setShowUserMenu(false)}
              >
                My Profile
              </Link>

              <hr className="menu-divider" />

              <button
                onClick={handleLogout}
                className="logout-link"
                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>

      {showTenantModal && (
        <SwitchTenantModal onClose={() => setShowTenantModal(false)} />
      )}
    </header>
  );
};

export default Header;
